import { Grid, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { marginBottom } from "../../../config/styles";
import { basic, validationMessages } from '../../../config/validations';
import { setFocusElement, setReRender, toggleRightDrawer } from '../../../store/global/actions';
// import IconSelector from "../../atoms/IconSelector";
import { invokeGetService, invokePostService } from '../../../store/global/actions';
import { findIconSource, formatFetchedCustomIcons, generateIconFileName, validateNonAsciiChars } from '../../../utils/commonUtils';
import { IconSelector } from '../../atoms/IconSelectorV2';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";

const elementTypes = {
    infer_engine: "Infer Engine",
    generate_engine: "Generate Engine",
    learn_engine: "Learn Engine",
}

export default function Details({ element, onClose, onCompletion }) {
    const dispatch = useDispatch();
    
    const [analytics, setAnalytics] = useState(element);
    const [prevIconName, setPrevIconName] = useState("");
    const [icon, setIcon] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const { register, handleSubmit, formState: { errors }, reset, setError, watch } = useForm({
        defaultValues: {
            name: analytics?.name,
            desc: analytics?.desc
        }
    });

    const nameValue = watch("name");


    useEffect(() => {
        dispatch(invokeGetService('getClusterlet', [element.id])).then(res => {
           if(res?.status == true) {
            setAnalytics(res?.data);
            setPrevIconName(res?.data?.icon || "");
            setIcon(formatFetchedCustomIcons(res?.data));
            reset({
                name: res?.data?.name,
                desc: res?.data?.attributes?.desc
            });
           } else {
            if (res?.code === 255) {
                dispatch(toggleRightDrawer());
                dispatch(setReRender());
                dispatch(setFocusElement({}));
            }
           }
        })
    }, [])

    const cancelUpdation = () => {
        dispatch(toggleRightDrawer())
    }

    const messages = { ...validationMessages, validate: 'This name is already used' };

    const onUpdate = async ({ name, desc }) => {
        const payload = {
            name,
            attributes: { ...analytics.attributes, desc },
            type: analytics.type
        }   

        if(prevIconName != generateIconFileName(icon)){
            payload.icon = generateIconFileName(icon)
            payload.iconSource = findIconSource(icon)
        }

        setLoading(true);
        dispatch(invokePostService('editClusterlet', {clusterlet: payload}, [element.id])).then(res => { 
			setLoading(false);
			if (res?.status === true) {
                if (analytics.name !== name) {
                    dispatch(setFocusElement({ id: analytics._id, type: 'analytics', templateId: '', name: name, icon: analytics?.icon, desc: analytics?.attributes?.desc }));
                }
                onCompletion(elementTypes[element?.subType] || `${process.env.REACT_APP_ANALYTICS}`, 'edit')
                onClose();
			} else {
                if (res?.code === "600") {
                    res?.errors?.forEach(error => {
                        setError(error.name, {message: error.message});
                    });
                }
                if (res?.code === 255) {
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                }
            }
		});

    }


    return (
        <>

            <Grid xs={12} style={marginBottom}>
                <TextField
                    name="name"
                    autoFocus
                    fullWidth
                    type={"text"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type] : ''}
                />
            </Grid>


            <Grid xs={12} style={marginBottom}>
                <TextField
                    id="desc"
                    type={"text"}
                    fullWidth
                    rows={4}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    multiline
                    name="desc"
                    inputRef={register({ required: false, validate: validateNonAsciiChars })}
                    error={errors?.desc}
                    helperText={errors?.desc?.message || ''}

                />
            </Grid>

            <Grid item xs={12} style={{ display: "flex", marginBottom: 20 }}>
                {/* <IconSelector onSelect={setIcon} current={icon} /> */}
                <IconSelector setSelectedIcon={setIcon} selectedIcon={icon} defaultSearchTag={nameValue}/>
            </Grid>

            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }}>
                <UpdateCancel updateDisable={loading} content={loading ? 'Updating..' : 'Update'} onUpdate={handleSubmit(onUpdate)} onCancel={cancelUpdation} typesNotIn={['transaction', 'view']} />
            </Grid>

        </>

    )
}
